module.exports = __webpack_public_path__ + "static/media/weebly.23f1cf18.png";